import { render, staticRenderFns } from "./PensionOrderSuccess.vue?vue&type=template&id=863c4196&"
import script from "./PensionOrderSuccess.vue?vue&type=script&lang=ts&"
export * from "./PensionOrderSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./PensionOrderSuccess.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports